<div class="date-selection-bar mat-elevation-z8">
    <div class="range-selection">
        <div class="year-month-selection">
            <mat-form-field subscriptSizing="dynamic">
                <mat-label>Year</mat-label>
                <mat-select
                    [(ngModel)]="selectedYear"
                    (valueChange)="selectedYearChanged($event)"
                    aria-label="selectedYear">
                    <mat-option *ngIf="config.page === 3"><em></em></mat-option>
                    <mat-option *ngFor="let year of years; trackBy: trackBy" [value]="year">{{ year }}</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field subscriptSizing="dynamic">
                <mat-label>Month</mat-label>
                <mat-select
                    [(ngModel)]="selectedMonth"
                    (valueChange)="selectedMonthChanged($event)"
                    [disabled]="!selectedYear"
                    aria-label="selectedMonth"
                    placeholder="Month">
                    <mat-option><em></em></mat-option>
                    <mat-option
                        *ngFor="let month of months; trackBy: trackBy"
                        [value]="month"
                        style="font-weight: bold"
                        >{{ month }}</mat-option
                    >
                </mat-select>
            </mat-form-field>
        </div>

        <div class="from-until-selection" *ngIf="config.page === 4" fxHide fxShow.gt-xs>
            <mat-form-field subscriptSizing="dynamic" fxHide fxShow.gt-sm class="date-selector">
                <mat-label>From</mat-label>
                <input matInput [matDatepicker]="fromPicker" [(ngModel)]="criteria.startDate" />
                <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
                <mat-datepicker #fromPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field subscriptSizing="dynamic" fxHide fxShow.gt-sm class="date-selector">
                <mat-label>Until</mat-label>
                <input matInput [matDatepicker]="tillPicker" [(ngModel)]="criteria.endDate" />
                <mat-datepicker-toggle matSuffix [for]="tillPicker"></mat-datepicker-toggle>
                <mat-datepicker #tillPicker></mat-datepicker>
            </mat-form-field>
        </div>
    </div>

    <button
        mat-icon-button
        color="accent"
        (click)="execute()"
        [disabled]="!criteria.startDate || !criteria.endDate"
        matTooltip="{{ config.iconTitle }}">
        <mat-icon>{{ config.icon }}</mat-icon>
    </button>
</div>
